import * as React from "react";
import { Route, Switch, Redirect, Link, NavLink } from "react-router-dom";
import * as cn from "classnames";
import { History } from "history";
import LocationDescriptor = History.LocationDescriptor;
import Breadcrumb from "components/Breadcrumb";
import { secondaryText } from "../../colors";
import BusyFromPromise from "components/BusyFromPromise/BusyFromPromise";
import BusyRefreshIndicator from "components/BusyRefreshIndicator";
const styles = require("./style.less");

interface SectionTitleProps {
    title: JSX.Element;
    className?: string;
    sectionControl?: React.ReactNode;
    titleLogo?: JSX.Element;
    breadcrumbTitle?: string; // If specified, this text will display above the title.
    breadcrumbPath?: LocationDescriptor; // If specified, this will link your breadcrumb title.
    busy?: Promise<any> | boolean;
    enableLessIntrusiveLoadingIndicator?: boolean;
}

const SectionTitle: React.StatelessComponent<SectionTitleProps> = props => {
    return <div className={cn(styles.container, props.className)}>
        <div className={styles.titleContainer}>
            <Breadcrumb title={props.breadcrumbTitle} path={props.breadcrumbPath} />
            <div className={styles.title}>
                {props.titleLogo && <div className={styles.logo}>{props.titleLogo}</div>}
                <h2 className={styles.header}>{props.title}</h2>
                {/* We show a less intrusive refresh indicator for screens that have auto-refresh implemented (because the main horizontal loading bar is annoying). */}
                {props.enableLessIntrusiveLoadingIndicator &&
                <div className={styles.refreshIndicator}>
                    <BusyFromPromise promise={props.busy}>
                    {(busy: boolean) => {
                        return busy && props.enableLessIntrusiveLoadingIndicator
                        ? <div className={styles.refreshContainer}>
                            <BusyRefreshIndicator show={true} />
                        </div>
                        : null;
                    }}
                    </BusyFromPromise>
                </div>}
            </div>
        </div>
        {props.sectionControl}
    </div>;
};

export default SectionTitle;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/SectionTitle/index.tsx